export default "__VITE_ASSET__42e11c8d__"